import React from 'react';
import { GiChicken, GiRunningNinja, GiBeerStein, GiTrophyCup } from 'react-icons/gi';

const HowToPlay = () => {
  const steps = [
    {
      icon: <GiChicken className="w-16 h-16 text-[#E57373]" />,
      title: "Start the Hunt",
      description: "Each player contributes £20 to the pot. Use the game code to join and get assigned as either a Chicken or a Chaser."
    },
    {
      icon: <GiBeerStein className="w-16 h-16 text-[#E57373]" />,
      title: "Hide & Drink",
      description: "Chickens buy the first round and sneak off to hide in a pub. Chasers wait 30 minutes, finish their drinks, then begin the search."
    },
    {
      icon: <GiRunningNinja className="w-16 h-16 text-[#E57373]" />,
      title: "The Chase",
      description: "Teams of Chasers hunt through London's pubs. Upload a photo at each stop - if no Chickens are found, have a drink before moving on!"
    },
    {
      icon: <GiTrophyCup className="w-16 h-16 text-[#E57373]" />,
      title: "Victory",
      description: "Found the Chickens? Join them in drinking through the pot! Failed to find them? Time for a gin shot!"
    }
  ];

  return (
    <section id="how-to-play" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-medium text-gray-800 mb-6 text-center">How to Play</h2>
        <p className="text-xl text-gray-600 text-center max-w-2xl mx-auto mb-12">
          Dive into the fun of <span className="text-[#E57373]">Chase the Chickens</span> – a game of drinks, laughs, and a search to remember!
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center text-center bg-gray-50 rounded-xl p-6 hover:shadow-lg transition duration-300">
              <div className="mb-4 transform hover:scale-110 transition duration-200">
                {step.icon}
              </div>
              <h3 className="text-xl font-medium text-gray-800 mb-3">
                {step.title}
              </h3>
              <p className="text-gray-600">
                {step.description}
              </p>
              <div className="mt-4 w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-2xl font-bold text-[#E57373]">
                {index + 1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToPlay;